// Keep dashboard periods and the linked accounting registers on the same basis.
// Invoiced receipts retain their issue date; standalone receipts have no invoice.
export function getPaymentAccountingDate(payment) {
  return payment?.issueDate || payment?.invoiceDate || payment?.emittedAt || payment?.paymentDate || payment?.dueDate || '';
}

export function getExpenseAccountingDate(expense) {
  return expense?.issueDate || expense?.invoiceDate || expense?.emittedAt || expense?.dueDate || '';
}
